export default "__VITE_ASSET__cJKgdHX3__"